/** Search parameters used in the Konvive API. */
export const searchParametersKonviveApi = {
    MANAGERS: 'client__id__in',
}

/** Get the translation key of the origin of creation for the Konvives. */
export const origineOfCreationTranslate = {
    IMPORT: 'import',
    KONVIVES: 'konvives',
    MANUAL: 'manual',
}

/** Get the translation key of error when importing the Konvive users. */
export const errorKonvivesImportTranslate = {
    CARD_ID: 'cardNumberAlreadyInUse',
    EMAIL: 'emailError',
    EMAIL_IN_USE: 'emailAlreadyInUse',
    MIFARE_CODE: 'mifareCodeAlreadyInUse',
    NUMERIC_TYPE: 'errorImportNumeric',
    STRING_TYPE: 'errorImportString',
}
